import * as React from "react";
import Header from "../../Header";
import RankBadgesContainer from "../../Achievements/badges/overallrank/container"
import SkillsContainer from "../../Achievements/badges/WomenInStem/container";

declare const I18n

type Props = {
  skills: any[];
  skillLevels: any[];
  learnerSkillPoints: any[];
  overallRank: any[];
  learnerOverallRank: any;
  skillBadges: any[];
  learnerBadges: any[];
  learnerName: string;
  isLearner: boolean;
};

const LearnerAchievements: React.FC<Props> = ({
  skills,
  skillLevels,
  learnerSkillPoints,
  overallRank,
  learnerOverallRank,
  skillBadges,
  learnerBadges,
  isLearner,
  learnerName
}) => {
  const skillArragement = [
    "growth_mindset",
    "creativity",
    "critical_thinking",
    "communication",
    "collaboration",
    "global_citizenship",
  ]

  const sortedSkills = skills.sort(
    (a, b) =>
      skillArragement.indexOf(a.slug) - skillArragement.indexOf(b.slug)
  );

  const headerTitle = isLearner ? I18n.t("views.achievements.common.my_achievements") : I18n.t("views.achievements.common.learner_achievement", { name: learnerName })

  return (
    <>
      <Header title={headerTitle} showIcon={false} />
      <div className="achievement-description">
        <p>{I18n.t("views.achievements.badge.messaging.description_1")}</p>
        <p>{I18n.t("views.achievements.badge.messaging.description_2")}</p>
      </div>
      <RankBadgesContainer overall_ranks={overallRank} learner_overall_rank={learnerOverallRank} />
      {sortedSkills.map((skill) => {
        const skillLevelsForSkill = skillLevels.filter(
          (level) => level.skill_id === skill.id
        );

        const learnerPointsForSkill = learnerSkillPoints.find(
          (sp) => sp.skill_id === skill.id
        )?.points ?? 0;

        const mergedBadgeObjects = skillBadges
          .filter((badge) =>
            skillLevelsForSkill.some((level) => level.badge_id === badge.id)
          )
          .map((badge) => {
            const matchingLevel = skillLevelsForSkill.find(
              (level) => level.badge_id === badge.id
            );

            const isUnlocked = learnerBadges.some(
              (lb) => lb.badge_id === badge.id
            );

            return {
              ...badge,
              currentPoints: learnerPointsForSkill,
              pointsRequired: matchingLevel.points_required,
              unlocked: isUnlocked,
            };
          });

        return (
          <SkillsContainer
            key={skill.slug}
            skill={skill}
            filteredBadges={mergedBadgeObjects}
          />
        );
      })}
    </>
  );
};

export default LearnerAchievements;
